import { GraphQLClient } from "graphql-request";
import { tokenPrefix } from "../common";

export namespace GraphQL {
    export function createClient(endpoint: string, authToken: string): GraphQLClient {
        return new GraphQLClient(`${endpoint}/graphql/`, {
            headers: { Authorization: `${tokenPrefix} ${authToken}` }
        });
    }
};
